/** The registrar's Help retention register for one course (#1413): deadlines, review holds, and their history. No message body. */
import { api } from "./client";
import { commitOptions } from "./commitSeams";

export type RetentionAction = "extend" | "hold" | "release";

export interface RetentionEvent {
  action: "extended" | "held" | "released" | "purged";
  /** ISO dates. */
  from_deadline: string;
  to_deadline: string | null;
  reason: string | null;
  actor_kind: "registrar" | "retention_job";
  actor_name: string | null;
  recorded_at: string;
}

export interface RetentionThread {
  thread_id: string;
  student_id: string;
  learner_name: string | null;
  sid: string | null;
  opened_at: string;
  /** ISO date: kept through this day, purged after it unless held. */
  retention_deadline: string;
  held: boolean;
  hold_reason: string | null;
  held_at: string | null;
  held_by_name: string | null;
  /** Newest first. */
  history: RetentionEvent[];
}

export interface RetentionRegister {
  threads: RetentionThread[];
  /** Threads of this course the retention job has purged. */
  purged: number;
}

export interface RetentionChange {
  action: RetentionAction;
  /** ISO date; an extension only. */
  deadline?: string | null;
  reason: string;
}

export interface RetentionChanged {
  state: "confirmed";
  thread_id: string;
  retention_deadline: string;
  held: boolean;
}

const base = (courseId: string) => `/courses/${encodeURIComponent(courseId)}/help-retention`;

export const helpRetentionKey = (courseId: string) => ["help-retention", courseId] as const;
export const HELP_RETENTION_ACTION = "help-retention.change";

export const helpRetentionApi = {
  read: (courseId: string) => api.get<RetentionRegister>(base(courseId)),
  change: (courseId: string, threadId: string, body: RetentionChange, key: string) =>
    api.post<RetentionChanged>(`${base(courseId)}/${encodeURIComponent(threadId)}`, body, commitOptions(key)),
};
